export const FactsandFiguresActions = {
  GET_FACTSANDFIGURES_SECTIONS: "GET_FACTSANDFIGURES_SECTIONS",
  SET_FACTSANDFIGURES_SECTIONS: "SET_FACTSANDFIGURES_SECTIONS",
};
